import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import config from '@nerdwallet/app-config';
import { InMemoryCache, BROWSER_KEY } from '..';
import getApolloClient, { getPossibleTypes, getTypePolicies } from './shared';

/**
 * Light wrapper around the shared apollo-client implementation.
 */
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var acOptions = _objectSpread({
    // eslint-disable-next-line no-console
    log: function log(msg) {
      return config.DEBUG && console.warn(msg);
    }
  }, options);

  if (options.createCache) {
    acOptions.cache = options.createCache().restore(window[BROWSER_KEY]);
    delete acOptions.createCache;
  } else if (!options.cache) {
    acOptions.cache = new InMemoryCache({
      possibleTypes: getPossibleTypes(options),
      typePolicies: getTypePolicies(options)
    }).restore(window[BROWSER_KEY]);
  }

  return getApolloClient(acOptions);
});